module.exports = __webpack_public_path__ + "static/img/03.9cb5c717.jpg";